import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '演艺经历', path: '/category/acting-career' },
    { label: '作品集', path: '/category/works' },
    { label: '写真图集', path: '/category/gallery' },
    { label: '最新动态', path: '/category/news' },
    { label: '访谈记录', path: '/category/interviews' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '品牌故事', path: '/about#brand' },
    { label: '口碑评价', path: '/about#reputation' },
  ],
  social: [
    { label: '微博', url: 'https://weibo.com/', icon: 'ri-weibo-line' },
    { label: 'B站', url: 'https://space.bilibili.com/', icon: 'ri-bilibili-line' },
    { label: '抖音', url: 'https://www.douyin.com/', icon: 'ri-tiktok-line' },
    { label: '小红书', url: 'https://www.xiaohongshu.com/', icon: 'ri-red-packet-line' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold tracking-wide">
                孟若羽
              </span>
            </Link>
            <p className="text-secondary-300 text-sm leading-relaxed max-w-xs">
              孟若羽官方粉丝站，为您提供最新、最全面的孟若羽个人资讯、作品动态与粉丝互动内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
              快速导航
            </h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-secondary-300 hover:text-background-50 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
              关于本站
            </h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-secondary-300 hover:text-background-50 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
              关注我们
            </h4>
            <div className="flex items-center gap-3 mb-4">
              {footerLinks.social.map((item) => (
                <a
                  key={item.label}
                  href={item.url}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-600 hover:text-background-50 transition-all duration-200"
                  aria-label={item.label}
                >
                  <i className={`${item.icon} text-lg`}></i>
                </a>
              ))}
            </div>
            <p className="text-secondary-400 text-xs">
              商务合作：contact@mengruoyu.com
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-secondary-400 text-xs">
            &copy; {new Date().getFullYear()} 孟若羽官方粉丝站 版权所有
          </p>
          <p className="text-secondary-500 text-xs">
            本站为非官方粉丝站点，仅供信息聚合与分享
          </p>
        </div>
      </div>
    </footer>
  );
}